import { BasePreferences, IPreferencesService } from '@base/features/preferences/model/types';
import { useBehaviorSubject, t } from '@base/utils/helpers';
import CheckboxSwitch from '@ui-kit/components/checkboxSwitch';
import { container } from 'tsyringe';
import styles from '../styles/preferencesControl.module.scss';

type PreferencesDict = { title: string; key: keyof BasePreferences };

export default function PreferencesAudioControl(props: { children: PreferencesDict[] }) {
  const preferencesService: IPreferencesService<BasePreferences> = container.resolve('preferencesService');

  const preferences = useBehaviorSubject(preferencesService.onPreferencesChanged);
  const trigger: PreferencesDict = { title: 'all_mute', key: 'SOUND_ALL_MUTE' };
  return (
    <div className={styles.preferencesControl}>
      <CheckboxSwitch
        id={trigger.key}
        key={trigger.key}
        name={trigger.key}
        checked={preferences[trigger.key] as boolean}
        handler={(e) => {
          preferencesService.updatePreferences('SOUND_ALL_MUTE', e.target.checked);
        }}
      >
        {t(trigger.title)}
      </CheckboxSwitch>
      {props.children.map((preference) => (
        <CheckboxSwitch
          id={preference.key}
          key={preference.key}
          name={preference.key}
          checked={preferences[trigger.key] ? false : (preferences[preference.key] as boolean)}
          disabled={Boolean(preferences[trigger.key])}
          handler={(e) => {
            preferencesService.updatePreferences(preference.key, e.target.checked);
          }}
        >
          {t(preference.title)}
        </CheckboxSwitch>
      ))}
    </div>
  );
}
